<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <!-- Illustration -->
  <div class="illustration">
    <img src="assets/img/bg_verify_email.svg" alt="Verify Account" width="220" />
  </div>

  <!-- Title & Subtitle -->
  <div class="text-center">
    <h2>Verify your account</h2>
    <p>We sent you a code to your email at:
      <strong>{{ email }}</strong>
    </p>
  </div>

  <!-- OTP Input Area -->
  <div class="otp-container">
    <label class="otp-label">ENTER CODE</label>
    <form style="margin-top: 8px;" class="opt-form" (ngSubmit)="submit()">
      <ng-otp-input 
        [(ngModel)]="otpValue" 
        *ngIf="showOtp" 
        [ngModelOptions]="{ standalone: true }"
        [config]="{ 
            length: 6, 
            allowNumbersOnly: true,
            inputStyles: {
              'width': '48px',
              'height': '48px',
              'margin': '0 5px',
              'borderRadius': '8px',
              'border': '1px solid var(--ion-color-dark)',
              'textAlign': 'center',
              'fontSize': '18px',
              'fontWeight': '600'
            },
            containerStyles: {
              'display': 'flex',
              'justifyContent': 'space-between',
              'alignItems': 'center',
              'gap': '10px'
            }
          }" (onInputChange)="onOtpChange($event)">
      </ng-otp-input>
    </form>
    <!-- Resend & Contact Links -->
    <div class="text-center small-text">
      <p>Didn’t get a code? <a (click)="resendCode()">Resend the code</a></p>
      <p style="padding-top: 24px; padding-bottom: 24px;"><a (click)="contactUs()">Contact us</a></p>
    </div>
  </div>

</ion-content>